var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_4269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.558 18.9981L26.0619 17.5567C26.3138 16.1973 26.3138 14.8028 26.0619 13.4434L28.558 12.002C28.8451 11.8379 28.974 11.4981 28.8802 11.1817C28.2298 9.09576 27.1224 7.20904 25.6752 5.63873C25.4525 5.39849 25.0892 5.3399 24.808 5.50396L22.3119 6.94537C21.263 6.04302 20.056 5.34576 18.7494 4.88873V2.01177C18.7494 1.68365 18.5209 1.39654 18.1986 1.32623C16.0482 0.845758 13.8451 0.869196 11.8002 1.32623C11.4779 1.39654 11.2494 1.68365 11.2494 2.01177V4.89459C9.9486 5.35748 8.74157 6.05474 7.68688 6.95123L5.19665 5.50982C4.90954 5.34576 4.55211 5.39849 4.32946 5.64459C2.88219 7.20904 1.77477 9.09576 1.12438 11.1876C1.02477 11.504 1.15954 11.8438 1.44665 12.0079L3.94274 13.4493C3.69079 14.8086 3.69079 16.2032 3.94274 17.5626L1.44665 19.004C1.15954 19.168 1.03063 19.5079 1.12438 19.8243C1.77477 21.9102 2.88219 23.7969 4.32946 25.3672C4.55211 25.6075 4.9154 25.6661 5.19665 25.502L7.69274 24.0606C8.74157 24.9629 9.9486 25.6602 11.2552 26.1172V29.0001C11.2552 29.3282 11.4838 29.6153 11.806 29.6856C13.9564 30.1661 16.1595 30.1426 18.2045 29.6856C18.5267 29.6153 18.7552 29.3282 18.7552 29.0001V26.1172C20.056 25.6544 21.263 24.9571 22.3177 24.0606L24.8138 25.502C25.1009 25.6661 25.4584 25.6133 25.681 25.3672C27.1283 23.8028 28.2357 21.9161 28.8861 19.8243C28.974 19.502 28.8451 19.1622 28.558 18.9981ZM14.9994 20.1876C12.4154 20.1876 10.3119 18.084 10.3119 15.5001C10.3119 12.9161 12.4154 10.8126 14.9994 10.8126C17.5834 10.8126 19.6869 12.9161 19.6869 15.5001C19.6869 18.084 17.5834 20.1876 14.9994 20.1876Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_4269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.ada5b0dd16fcf08861f5f6af359dcd4e.svg";
export { ForwardRef as ReactComponent };